export interface Project {
  slug: string;
  title: string;
  year: number;
  role: string;
  status: "live" | "archived" | "wip";
  thumb: string;
  thumbCrt: string;
  tags: string[];
  liveUrl?: string;
  repoUrl?: string;
  summary: string;
  caseStudy?: {
    problem: string;
    role: string;
    stack: string[];
    process: { title: string; body: string }[];
    outcome: string;
    media: { kind: "image" | "video"; src: string; alt: string }[];
  };
}

export const PROJECTS: Project[] = [
  {
    slug: "threejs-portfolio-boilerplate",
    title: "Three.js Portfolio Boilerplate",
    year: 2024,
    role: "Author",
    status: "live",
    thumb: "/textures/threejs-portfolio.png",
    thumbCrt: "/textures/threejs-portfolio.png",
    tags: ["three.js", "react", "r3f", "starter"],
    liveUrl: "https://3js-portfolio-boiler.netlify.app/",
    summary: "Boilerplate for shipping a creative 3D portfolio in under a day.",
    caseStudy: {
      problem:
        "Every new 3D portfolio re-implements the same loader, camera tweens, theme system.",
      role: "Author and maintainer.",
      stack: ["React", "R3F", "drei", "GSAP", "Vite"],
      process: [
        {
          title: "Reduce",
          body: "Strip prior portfolios to their re-usable spine.",
        },
        {
          title: "Document",
          body: "README with 6 named camera setups and 4 hotspot templates.",
        },
        { title: "Ship", body: "Single command scaffold." },
      ],
      outcome:
        "Used by 3 other devs (and me) for their first creative-dev portfolio.",
      media: [],
    },
  },
  {
    slug: "threejs-wizardy-portfolio",
    title: "Three.js Wizardy Portfolio",
    year: 2024,
    role: "Designer + Developer",
    status: "live",
    thumb: "/textures/threejs-wizardy.png",
    thumbCrt: "/textures/threejs-wizardy.png",
    tags: ["three.js", "shaders", "gsap", "portfolio"],
    liveUrl: "https://3-js-wizardy-portfolio.vercel.app/",
    summary:
      "Spellbook-themed portfolio with custom shaders and scroll-triggered scenes.",
    caseStudy: {
      problem:
        "Static portfolio felt too clinical for a creative dev brand. Needed a memorable hook.",
      role: "Solo designer and developer.",
      stack: ["Three.js", "GSAP", "Vite", "GLSL"],
      process: [
        {
          title: "Theme",
          body: "Spellbook + grimoire aesthetic, parchment textures, candlelight palette.",
        },
        {
          title: "Hook",
          body: "Hero spell animation runs on first paint; scroll triggers section reveals.",
        },
        {
          title: "Polish",
          body: "Custom shaders for ink + candle flicker, audio cue on chapter change.",
        },
      ],
      outcome: "Highest dwell time of any portfolio I've shipped to date.",
      media: [],
    },
  },
  {
    slug: "ui-restaurant-concept",
    title: "UI Restaurant Concept",
    year: 2023,
    role: "Designer + Developer",
    status: "live",
    thumb: "/textures/ui-restaurant.png",
    thumbCrt: "/textures/ui-restaurant.png",
    tags: ["react", "ui", "concept"],
    liveUrl: "https://ui-gericht.netlify.app/",
    summary:
      "Editorial-style restaurant marketing page exploring typography + texture.",
  },
];
